import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  container: {
    background: theme.palette.white,
    borderRadius: 8,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    border: "1px solid #e8e8e8",
    boxShadow: "-2px 2px 40px #0000000d",
    width: "500px",
    textAlign: "center",
    padding: "40px",
    gap: "20px",

    [theme.breakpoints.down("sm")]: {
      width: "300px",
      padding: "16px",
    },
  },
  magicWand: {
    marginBottom: theme.spacing(2.5),
    width: "80px",
    height: "80px",
  },
  magicLinkContainer: {
    display: "flex",
    gap: "4px",
    flexDirection: "column",
  },
  emailDetails: {
    margin: `0 ${theme.spacing(7.5)}`,
    textAlign: "left",

    [theme.breakpoints.down("sm")]: {
      margin: `0 ${theme.spacing(4)}`,
    },
  },
  changeEmailButton: {
    height: "18px",
    width: "18px",

    [theme.breakpoints.down("sm")]: {
      display: "none",
    },

    "& svg": {
      height: "18px",
      width: "18px",
    },
  },
}));
